function isMode1996() {
    return document.cookie.split('; ').some(row => row === 'mode1996=true');
}

document.addEventListener('DOMContentLoaded', function() {
    if (isMode1996() || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const images = document.querySelectorAll('.image-parallax');

    if (!images.length) return;

    // The hero's pause button (a11y.js) switches the effect off: instances
    // are destroyed while paused and recreated for the images already in play
    // when it is resumed.
    let paused = document.documentElement.classList.contains('motion-paused-all');
    const activated = new Set();
    const instances = new Map();

    function activate(image) {
        if (paused || instances.has(image)) {
            return;
        }
        instances.set(image, new simpleParallax(image, {
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)',
            scale: 1.15,
        }));
    }

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                activated.add(entry.target);
                activate(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '200px 0px',
    });

    document.addEventListener('tb:motion', function(e) {
        paused = !!(e.detail && e.detail.paused);

        if (paused) {
            instances.forEach(function(instance) {
                instance.destroy();
            });
            instances.clear();
        } else {
            activated.forEach(activate);
        }
    });

    images.forEach(function(image) {
        observer.observe(image);
    });
});

(function($) {
    'use strict';

    if (isMode1996()) {
        return;
    }

    const $body = $(document.body);

    $body.on('mouseover', '.coworker', function() {
        const video_id = $(this).attr('data-video');
        const video = document.getElementById(video_id);
        if (video) {
            video.play();
        }
    });

    $body.on('mouseleave', '.coworker', function() {
        const video_id = $(this).attr('data-video');
        const video = document.getElementById(video_id);
        if (video) {
            video.pause();
        }
    });

    // Imprint teasers without a thumbnail video stack their "Galleri"
    // images on top of the featured image (see get_teaser_media_html());
    // cycle through them every second while hovered.
    $body.on('mouseover', '.image-container', function() {
        const $wrapper = $(this);
        if ($wrapper.data('galleryHoverInterval')) {
            return;
        }

        const $images = $wrapper.find('.gallery-hover-image');
        if (!$images.length) {
            return;
        }

        let index = 0;
        const showImage = function(i) {
            $images.removeClass('opacity-100').addClass('opacity-0');
            $images.eq(i).removeClass('opacity-0').addClass('opacity-100');
        };

        showImage(index);
        const intervalId = setInterval(function() {
            index = (index + 1) % $images.length;
            showImage(index);
        }, 1000);

        $wrapper.data('galleryHoverInterval', intervalId);
    });

    $body.on('mouseleave', '.image-container', function() {
        const $wrapper = $(this);
        const intervalId = $wrapper.data('galleryHoverInterval');
        if (intervalId) {
            clearInterval(intervalId);
            $wrapper.removeData('galleryHoverInterval');
        }
        $wrapper.find('.gallery-hover-image').removeClass('opacity-100').addClass('opacity-0');
    });

}(jQuery));
